import { useQuery } from '@tanstack/react-query';
import { Marketplace } from '../@types/api';
import { QUERY_KEYS } from '../constants';
import API_ROUTES from '../constants/apiRoutes';
import { getData } from '../utils/api';
import { getItemFromSessionStorage } from '../utils/storageHelper';
import { FEED_SOURCE } from '../constants/enums';

export const useMarketplace = () => {
  const queryResult = useQuery<Marketplace>({
    queryKey: [QUERY_KEYS.marketplaceConfig],
    queryFn: () => getData(API_ROUTES.MARKETPLACE_CONFIG, undefined, 'crm'),
  });

  const config: Marketplace | undefined = queryResult.data ?? getItemFromSessionStorage('marketplace');

  const isStandaloneCasino = config?.marketplaceConfig?.products?.sportsbook === false;

  const feedSource = config?.sportsbookConfig?.feedSource || FEED_SOURCE.FEED_THE_BET;
  const isFTBFeed = feedSource === FEED_SOURCE.FEED_THE_BET;
  const isOMFeed = feedSource === FEED_SOURCE.ODDS_MATRIX;

  const hasAffiliateSystem = !!config?.marketplaceConfig?.systems?.affiliate;
  const isKycEnabled = config?.marketplaceConfig?.kyc?.enabled === true;

  return {
    ...queryResult,
    config,
    isStandaloneCasino,
    feedSource,
    isFTBFeed,
    isOMFeed,
    hasAffiliateSystem,
    isKycEnabled,
  };
};
